import React from "react";
import {
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  HatenaIcon,
  InstapaperIcon,
  LineIcon,
  LinkedinIcon,
  LivejournalIcon,
  MailruIcon,
  OKIcon,
  PinterestIcon,
  PocketIcon,
  RedditIcon,
  TelegramIcon,
  LinkedinShareButton,
  TumblrIcon,
  TwitterIcon,
  ViberIcon,
  VKIcon,
  WeiboIcon,
  WhatsappIcon,
  WorkplaceIcon,
  WhatsappShareButton,
  TwitterShareButton,
  TelegramShareButton,
} from "react-share";
import "./share.css";

const Sharebtn = () => {
  return (
    <p className="fixed_btn2 bot_small_bg_black sharebtn">
      <div className="show_on_hover">
        <TwitterShareButton
          url={window.location.href}
          title={window.location.href}
          className="Demo__some-network__share-button"
        >
          <TwitterIcon size={32} round />
        </TwitterShareButton>
        <TelegramShareButton
          url={window.location.href}
          title={window.location.href}
          className="Demo__some-network__share-button"
        >
          <TelegramIcon size={32} round />
        </TelegramShareButton>
        <WhatsappShareButton
          url={window.location.href}
          title={window.location.href}
          separator=":: "
          className="Demo__some-network__share-button"
        >
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
        <LinkedinShareButton
          url={window.location.href}
          className="Demo__some-network__share-button"
        >
          <LinkedinIcon size={32} round />
        </LinkedinShareButton>
      </div>
      <i className="fas fa-share-alt" />
    </p>
  );
};

export default Sharebtn;
